// src/components/CategoryItem.js
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

const Container = styled.div`
  flex: 1;
  min-width: 30%;
  height: 300px;
  position: relative;
  cursor: pointer;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const Info = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const Title = styled.h1`
  color: white;
  margin-bottom: 20px;
`;

const Button = styled.button`
  border: none;
  padding: 10px;
  background-color: white;
  color: gray;
  cursor: pointer;
  font-weight: 600;
`;

const CategoryItem = ({ item, mode }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (mode === "realestate") {
      navigate(`/realestates/${item.propertytype}`);
    } else {
      navigate(`/cars/${item.carproducer}`);
    }
  };

  return (
    <Container onClick={handleClick}>
      <Image src={item.img} />
      <Info>
        <Title>{item.title}</Title>
        <Button>SHOP NOW</Button>
      </Info>
    </Container>
  );
};

export default CategoryItem;
